import { Injectable } from '@angular/core';
import { NavLink } from '../model/navlink';

@Injectable({
  providedIn: 'root'
})
export class CurrentTabsService {
  tabs: NavLink[] = [];
  currentUser;
  constructor() { }
}
